import { apiAction } from "../models/requests";

import { IS_ADMIN } from "../constants/Constants";

const appendTokenName = (data) => {
  return data;
};

export function getUserImages(user) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }

  const data = {};

  if (user) {
    data.target_user = user;
  }

  appendTokenName(data);

  return apiAction({
    types: [
      "GETUSERIMAGE_REQUESTED",
      "GETUSERIMAGE_SUCCESS",
      "GETUSERIMAGE_FAILED",
    ],
    method: "POST",
    path: "get_user_images/",
    body: data,
  });
}

export function getUserImagesEx(user) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }

  const data = {};

  if (user) {
    data.target_user = user;
  }

  appendTokenName(data);

  return apiAction({
    types: [
      "GETUSERIMAGE_EX_REQUESTED",
      "GETUSERIMAGE_EX_SUCCESS",
      "GETUSERIMAGE_EX_FAILED",
    ],
    method: "POST",
    path: "admin/get_user_images/",
    body: data,
  });
}


export function getUserKasms() {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  appendTokenName(data);
  return apiAction({
    types: [
      "GETUSERKASMS_REQUESTED",
      "GETUSERKASMS_SUCCESS",
      "GETUSERKASMS_FAILED",
    ],
    method: "POST",
    path: "get_user_kasms/",
    body: data,
  });
}

export function getStatusKasms(kasm_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.kasm_id = kasm_id;
  appendTokenName(data);
  return apiAction({
    types: [
      "GETSTATUSKASMS_REQUESTED",
      "GETSTATUSKASMS_SUCCESS",
      "GETSTATUSKASMS_FAILED",
    ],
    method: "POST",
    credentials: "same-origin",
    path: "get_kasm_status/",
    body: data,
  });
}

export function execKasm(kasm_data) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.target_kasm = {};
  data.target_kasm.kasm_id = kasm_data.kasm_id;
  data.target_kasm.kasm_exec = kasm_data.kasm_exec;
  data.target_kasm.kasm_url = kasm_data.kasm_url;
  appendTokenName(data);
  return apiAction({
    types: ["EXECKASM_REQUESTED", "EXECKASM_SUCCESS", "EXECKASM_FAILED"],
    method: "POST",
    credentials: "same-origin",
    path: "exec_kasm/",
    body: data,
  });
}

export function updateKeepalive(kasm_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.kasm_id = kasm_id;
  appendTokenName(data);
  return apiAction({
    types: [
      "UPDATE_KEEPALIVE_REQUESTED",
      "UPDATE_KEEPALIVE_SUCCESS",
      "UPDATE_KEEPALIVE_FAILED",
    ],
    method: "POST",
    path: "keepalive/",
    body: data,
  });
}

export function setKasmPageInfo({pageSize,pageNo}){
  return {
      type : 'SET_KASM_PAGEINFO',
      payload : {pageSize,pageNo }
  }
}

export function destroyKasms(kasm_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.kasm_id = kasm_id;
  appendTokenName(data);
  return apiAction({
    types: [
      "DESTROY_KASMS_REQUESTED",
      "DESTROY_KASMS_SUCCESS",
      "DESTROY_KASMS_FAILED",
    ],
    method: "POST",
    path: "destroy_kasm/",
    body: data,
  });
}

export function createKasms(image_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = image_id;
  appendTokenName(data);
  return apiAction({
    types: [
      "CREATE_KASMS_REQUESTED",
      "CREATE_KASMS_SUCCESS",
      "CREATE_KASMS_FAILED",
    ],
    method: "POST",
    path: "request_kasm/",
    body: data,
  });
}

export function getClientSettings() {
  let data = {};
  appendTokenName(data);
  return apiAction({
    types: [
      "GET_CLIENT_SETTINGS_REQUESTED",
      "GET_CLIENT_SETTINGS_SUCCESS",
      "GET_CLIENT_SETTINGS_FAILED",
    ],
    method: "POST",
    path: "get_client_settings/",
    body: data,
  });
}

export function getUserDefaultImage() {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  appendTokenName(data);
  return apiAction({
    types: [
      "GET_DEFAULT_IMAGE_REQUESTED",
      "GET_DEFAULT_IMAGE_SUCCESS",
      "GET_DEFAULT_IMAGE_FAILED",
    ],
    method: "POST",
    path: "get_default_images/",
    body: data,
  });
}

export function createKasmShareId(kasm_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = { kasm_id: kasm_id };
  appendTokenName(data);
  return apiAction({
    types: [
      "CREATE_SHARE_ID_REQUESTED",
      "CREATE_SHARE_ID_SUCCESS",
      "CREATE_SHARE_ID_FAILED",
    ],
    method: "POST",
    path: "create_kasm_share_id/",
    body: data,
  });
}

export function destroyKasmShareId(kasm_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = { kasm_id: kasm_id };
  appendTokenName(data);
  return apiAction({
    types: [
      "DESTROY_SHARE_ID_REQUESTED",
      "DESTROY_SHARE_ID_SUCCESS",
      "DESTROY_SHARE_ID_FAILED",
    ],
    method: "POST",
    path: "delete_kasm_share_id/",
    body: data,
  });
}

export function getJoinKasm(share_id) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.share_id = share_id;
  appendTokenName(data);
  return apiAction({
    types: ["JOIN_KASM_REQUESTED", "JOIN_KASM_SUCCESS", "JOIN_KASM_FAILED"],
    method: "POST",
    credentials: "same-origin",
    path: "join_kasm/",
    body: data,
  });
}

export function getViewedKasms(kasms) {
  if (
    window.disableAPIActiveState == undefined ||
    window.disableAPIActiveState == 0
  ) {
    localStorage.setItem("unActiveStateSec", new Date().getTime());
  }
  let data = {};
  data.kasms = kasms;
  appendTokenName(data);
  return apiAction({
    types: [
      "GET_VIEWKASM_REQUESTED",
      "GET_VIEWKASM_SUCCESS",
      "GET_VIEWKASM_FAILED",
    ],
    method: "POST",
    credentials: "same-origin",
    path: "get_recent_kasms/",
    body: data,
  });
}
